import bindEvent from '../../scripts/util/bindEvent';
import findClsRemove from '../../scripts/util/findClsRemove';
import isElement from '../../scripts/util/isElement';
import $ from 'jquery';

const selectors = {
	tabs: '.js-tabs',
	tabList: '.js-tabs-list',
	bar: '.support .js-list-item',
	barList: '.js-list-items',
	content: '.js-tab-content',
	listItemCurrent: '.list-item-current',
	articleTitle: '.tabs__steps-title',
	articleContent: '.step__description',
	articleImage: '.step__description img',
	articleWrap: '.support .js-content-with-aside',
	spinner: '.spinner__wrapper',
	menuFixed: '.support .js-faq-menu-fixed',
	accordeon: '.js-accordeon',
	accordeonContent: '.js-accordion-content',
	accordionItemActive: '.accordeon__item_active'
};

const classes = {
	active: 'tabs__content_active',
	hidden: 'tabs__content_hidden',
	target: 'accordeon__item_state_active',
	activeBar: 'accordeon__text_state_active',
	listItemCurrent: 'list-item-current',
	spinnerHidden: 'spinner__wrapper-hidden',
	fixed: 'mod--menu-fixed'
};

const attr = {
	bar: 'data-tab',
	articleId: 'data-article-id',
	tabContent: 'data-tab-content'
};

const insertArticle = result => {
	const dataTab = document.querySelector(selectors.content);
	const articleTitle = $(dataTab).find(selectors.articleTitle);
	const articleContent = $(dataTab).find(selectors.articleContent);

	articleTitle.html(result.article.name);
	articleContent.html(result.article.body);

	const images = $(dataTab).find(selectors.articleImage);
	images.load(function () {
		$(this).addClass('img-is-loaded');
	});

	$(selectors.spinner).addClass(classes.spinnerHidden);
	$(selectors.content).removeClass(classes.hidden);
};

const clickHandler = e => {
	e.preventDefault();

	const el = e.currentTarget;
	const articleId = el.getAttribute(attr.articleId);
	const dataTab = document.querySelector(selectors.content);
	const height = $(selectors.menuFixed).find(selectors.accordeon).height();

	$(selectors.spinner).removeClass(classes.spinnerHidden);
	$(selectors.bar).removeClass('active');
	$(el).addClass('active');
	$(selectors.articleWrap).css('min-height', height + 'px');
	$(selectors.content).addClass(classes.hidden);

	const scrollPosition = $(selectors.accordeonContent).offset().top - 50;
	$(window).scrollTop(scrollPosition);

	let loadingFlag = false;
	if (loadingFlag !== true) {
		loadingFlag = true;
		const http = new XMLHttpRequest();
		http.open('GET', '/article-json?id=' + articleId, true);
		http.setRequestHeader('Content-type', 'application/json');
		http.send();
		http.onerror = err => {
			console.log(err.status);
		};
		http.onreadystatechange = () => {
			if (http.readyState === 4) {
				if (http.status === 200) {
					const result = JSON.parse(http.responseText);
					insertArticle(result);

					if (window.history && history.pushState) {
						history.pushState('', result.article.name, '/article?id=' + result.article.id);
					}

					const parentTabs = dataTab.closest(selectors.tabs);
					const parentBars = el.closest(selectors.barList);
					findClsRemove(parentTabs, classes.active);
					dataTab.classList.add(classes.active);
					findClsRemove(parentBars, classes.target);
					el.classList.add(classes.target);

					loadingFlag = false;
				}
				else {
					console.log(http.status);
				}
			}
		};
	}
};

const render = () => {
	if (isElement(selectors.tabs)) {
		bindEvent(selectors.bar, 'click', clickHandler);
		$(selectors.listItemCurrent).trigger('click').removeClass(classes.listItemCurrent);
	}
};
export default render;

